// import { Button as ButtonKendo } from "@progress/kendo-react-buttons";
// import { Menu, MenuItem, MenuSelectEvent } from "@progress/kendo-react-layout";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import sizeConfigs from "../configs/sizeConfigs";
import { USERNAME } from "../constante/localStorage";
import { planogramme, sections, statistiques, tableauDeBord } from "../constante/routes";
import { logout, setPlanoHeaderExpanded, setSectionHeaderExpanded } from "../redux/features/appStateSlice";
import { useAppSelector } from "../redux/store";
// import './menuheader.css';
import { Box, Button, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Toolbar } from "@mui/material";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useState } from "react";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LogoutIcon from '@mui/icons-material/Logout';

interface MenuHeaderProps {
  children: any;
}

export default function MenuHeader(props: MenuHeaderProps) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const planoHeaderExpanded = useAppSelector(state => state.appState.planoHeaderExpanded);
  const sectionHeaderExpanded = useAppSelector(state => state.appState.sectionHeaderExpanded);

  const [menuOpen, setMenuOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleMenuOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
    setMenuOpen(true);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setMenuOpen(false);
  };

  return (
    <>
      <Box
        style={{
          position: "fixed",
          display: 'flex',
          top: "0",
          width: "100%",
          boxShadow: "0 0 10px rgb(0 0 0)",
          zIndex: '10',
          height: sizeConfigs.topbar.height,
          backgroundColor: process.env.REACT_APP_COLOR,
          color: "white",
        }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            gap: 1,
          }}
        >
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
            sx={{ margin: 0 }}
            onClick={() => {
              if (location.pathname.includes("section"))
                dispatch(setSectionHeaderExpanded(!sectionHeaderExpanded))
              else dispatch(setPlanoHeaderExpanded(!planoHeaderExpanded));
            }}
          >
            <span className="k-icon k-font-icon k-i-menu k-icon-lg menu-text" />
          </IconButton>
          {process.env.REACT_APP_ENV?.toLowerCase() === "dev" && (
            <Box
              sx={{
                backgroundColor: "#f5f5f5",
                backgroundImage: "linear-gradient(#0000, #00000005)",
                borderColor: "#00000014",
                color: "#424242",
                borderRadius: "4px",
                padding: "2px 6px",
                fontWeight: "bold",
              }}
            >
              <span>
                {process.env.REACT_APP_ENV}
              </span>
            </Box>
          )}
        </Box>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            flex: 1,
            marginLeft: 2,
            "& > .menu-text": {
              fontSize: "1rem",
            }
          }}
        >
          <Button
            color="inherit"
            className={`menu-text ${location.pathname === planogramme ? "active-page" : ''}`}
            sx={{
              textTransform: "none",
              borderRadius: 0,
              borderBottom: (location.pathname === planogramme || location.pathname === "/") ? "white solid 0.25rem" : "none",
              marginTop: location.pathname === planogramme || location.pathname === "/" ? "0.25rem" : 0,
            }}
            onClick={() => navigate(planogramme)}
            variant="text"
          >Planogramme</Button>
          <Button
            color="inherit"
            className={`menu-text ${location.pathname === sections ? "active-page" : ''}`}
            sx={{
              textTransform: "none",
              borderRadius: 0,
              borderBottom: location.pathname === sections ? "white solid 0.25rem" : "none",
              marginTop: location.pathname === sections ? "0.25rem" : 0,
            }}
            onClick={() => navigate(sections)}
            variant="text"
          >Sections</Button>
          <Button
            color="inherit"
            className={`menu-text ${location.pathname === tableauDeBord ? "active-page" : ''}`}
            sx={{
              textTransform: "none",
              borderRadius: 0,
              borderBottom: location.pathname === tableauDeBord ? "white solid 0.25rem" : "none",
              marginTop: location.pathname === tableauDeBord ? "0.25rem" : 0,
            }}
            onClick={() => navigate(tableauDeBord)}
            variant="text"
          >Tableau de bord</Button>
          <Button
            color="inherit"
            className={`menu-text ${location.pathname === statistiques ? "active-page" : ''}`}
            sx={{
              textTransform: "none",
              borderRadius: 0,
              borderBottom: location.pathname === statistiques ? "white solid 0.25rem" : "none",
              marginTop: location.pathname === statistiques ? "0.25rem" : 0,
            }}
            onClick={() => navigate(statistiques)}
            variant="text"
          >Statistiques</Button>
        </Box>
        <Box>
          <Button
            color="inherit"
            sx={{ zIndex: 2147483647, position: 'relative', padding: '6px 12px', height: '100%', color: 'white', textTransform: 'none' }}
            variant="text"
            endIcon={<KeyboardArrowDownIcon />}
            onClick={(ev) => {
              if (menuOpen) handleMenuClose();
              else handleMenuOpen(ev);
            }}
          >
            Bienvenue {localStorage.getItem(USERNAME)}
            <Menu
              open={menuOpen}
              onClose={handleMenuClose}
              anchorEl={anchorEl}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
              transformOrigin={{ vertical: 'top', horizontal: 'right' }}
              sx={{
                width: "100%",
              }}
            >
              <MenuItem
                onClick={() => {
                  navigate('/account');
                  setMenuOpen(false);
                }}
                className="child-menu-item account-menu"

              >
                <ListItemIcon>
                  <AccountCircleIcon fontSize="medium" />
                </ListItemIcon>
                <ListItemText>Compte</ListItemText>
              </MenuItem>
              <MenuItem onClick={() => {
                navigate('/');
                dispatch(logout());
                setMenuOpen(false);
              }} className="child-menu-item account-menu">
                <ListItemIcon>
                  <LogoutIcon fontSize="medium" />
                </ListItemIcon>
                <ListItemText>Déconnexion</ListItemText>
              </MenuItem>
            </Menu>
          </Button>
        </Box>
      </Box>
      {props.children}
    </>
  );
}